import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Input, Button } from 'loyal-react'
import { profileStatuses } from '..'
import { buildPhone, getOnlyNumbers } from 'Participant/ducks'

class Company extends Component {
  state = {
    dirty: false,
    isValid: true,
    companyName: this.props.participant.companyName,
    cnpj: this.props.participant.cnpj,
    email: this.props.participant.email,
    mobile: {
      value: `${this.props.participant.phones.mobile.areaCode}${
        this.props.participant.phones.mobile.number
      }`,
      disabled:
        this.props.participant.phones.mobile &&
        this.props.participant.phones.mobile.disabled
    },
    workPhone: {
      value: `${this.props.participant.phones.work.areaCode}${
        this.props.participant.phones.work.number
      }`,
      disabled:
        this.props.participant.phones.work &&
        this.props.participant.phones.work.disabled
    }
  }

  isValid = () => {
    let isValid = true
    const mailValidator = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gim
    const { companyName, cnpj, email } = this.state

    const nameValidator = /^[\wÀ-Ÿ\-&\s()]+(?![http:https:])$/gim

    if (!nameValidator.test(companyName.value)) {
      this.setState({
        name: {
          value: companyName.value,
          disabled: companyName.disabled,
          error: 'Digite uma Razão Social válida'
        }
      })
      isValid = false
    }

    if (!companyName.value) {
      this.setState({
        name: {
          value: companyName.value,
          disabled: companyName.disabled,
          error: 'Digite sua Razão Social'
        }
      })
      isValid = false
    }

    if (!cnpj.value) {
      this.setState({
        cnpj: {
          value: cnpj.value,
          disabled: cnpj.disabled,
          error: 'Digite um CNPJ válido'
        }
      })
      isValid = false
    }

    if (!mailValidator.test(email.value)) {
      this.setState({
        email: {
          value: email.value,
          disabled: email.disabled,
          error: 'Digite um E-mail válido'
        }
      })
      isValid = false
    }

    this.setState({ isValid })
  }

  buttonProps = () =>
    this.props.participant.updatedSuccessfully
      ? { text: 'Salvo', className: 'btn btn-sm btn-featured bg-success' }
      : { text: 'Salvar', className: 'btn btn-sm btn-featured' }

  handleOnSubmit = () => {
    if (!this.state.isValid) return

    const { companyName, cnpj, email, mobile, workPhone } = this.state
    const {
      address,
      maritalStatus,
      genderType,
      birthDate
    } = this.props.participant

    let phones = []
    if (mobile.value) phones.push(buildPhone(mobile.value, 'MOBILE'))
    if (workPhone.value) phones.push(buildPhone(workPhone.value, 'WORK'))

    this.props.updateParticipant({
      name: companyName.value,
      documentNumber: getOnlyNumbers(cnpj.value),
      maritalStatus: maritalStatus.value,
      genderType: genderType.value,
      birthDate:
        birthDate.value && moment(birthDate.value, 'DD/MM/YYYY').format(),
      emails: [{ email: email.value, type: 'PERSONAL' }],
      status: profileStatuses[this.props.participant.statusId],
      profileId: this.props.participant.profileId,
      phones,
      address: {
        street: address.addressText.value,
        number: address.number.value,
        complement: address.complement.value,
        district: address.district.value,
        city: address.city.value,
        state: address.state.value,
        zipCode: address.zipCode.value
      }
    })
  }

  handleInputValid (input) {
    if (input.error) return false

    return null
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: { value: event.target.value },
      dirty: true
    })
  }

  componentDidUpdate () {
    if (!this.props.participant.updatedSuccessfully) return

    setTimeout(() => {
      this.setState({ dirty: false })
      this.props.expireUpdatedParticipant()
    }, 3000)
  }

  render () {
    return (
      <div className='col-12 px-2 pt-2'>
        <div className='row mx-0'>
          <Input
            id='input-name-profile-data'
            label='Razão social'
            className='col-12'
            minLength='1'
            maxLength='100'
            name='companyName'
            required
            data-error={this.state.companyName.error}
            valid={this.handleInputValid(this.state.companyName)}
            onChange={this.handleInputChange}
            value={this.state.companyName.value}
            disabled={this.state.companyName.disabled}
            onBlur={this.isValid}
          />

          <Input
            id='input-cnpj-profile-data'
            label='CNPJ'
            className='col-12 col-md-6 mt-2'
            required
            mask={[
              /\d/,
              /\d/,
              '.',
              /\d/,
              /\d/,
              /\d/,
              '.',
              /\d/,
              /\d/,
              /\d/,
              '/',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/
            ]}
            name='cnpj'
            data-error={this.state.cnpj.error}
            valid={this.handleInputValid(this.state.cnpj)}
            onChange={this.handleInputChange}
            value={this.state.cnpj.value}
            disabled={this.state.cnpj.disabled}
            onBlur={this.isValid}
          />
          <Input
            id='input-email-profile-data'
            label='E-mail'
            className='col-12 col-md-6 mt-2'
            required
            name='email'
            data-error={this.state.email.error}
            valid={this.handleInputValid(this.state.email)}
            onChange={this.handleInputChange}
            value={this.state.email.value}
            disabled={this.state.email.disabled}
            onBlur={this.isValid}
          />
          <Input
            id='input-phone-profile-data'
            label='Celular'
            className='col-12 col-md-6 mt-2'
            required
            mask={[
              '(',
              /[1-9]/,
              /\d/,
              ')',
              ' ',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              /\d/,
              /\d/
            ]}
            data-error={this.state.mobile.error}
            valid={this.handleInputValid(this.state.mobile)}
            onChange={this.handleInputChange}
            name='mobile'
            value={this.state.mobile.value}
            disabled={this.state.mobile.disabled}
            onBlur={this.isValid}
          />
          <Input
            id='input-workPhone-profile-data'
            label='Telefone comercial'
            className='col-12 col-md-6 mt-2'
            mask={[
              '(',
              /[1-9]/,
              /\d/,
              ')',
              ' ',
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              '-',
              /\d/,
              /\d/,
              /\d/,
              /\d/
            ]}
            name='workPhone'
            onChange={this.handleInputChange}
            value={this.state.workPhone.value}
            disabled={this.state.workPhone.disabled}
          />

          <div className='offset-md-6 col-12 col-md-6 mt-2'>
            <Button
              id='btn-save-participant'
              onClick={this.handleOnSubmit}
              disabled={!this.state.dirty || !this.state.isValid}
              {...this.buttonProps()}
              loading={this.props.participant.isUpdating}
            />
          </div>
        </div>
      </div>
    )
  }
}

const valueType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  disabled: PropTypes.string.isRequired
})

const valueTypeNumber = PropTypes.shape({
  value: PropTypes.number.isRequired,
  disabled: PropTypes.string.isRequired
})

Company.propTypes = {
  participant: PropTypes.shape({
    name: valueType,
    cnpj: valueType,
    companyName: valueType,
    email: valueType,
    phones: PropTypes.object,
    genderType: PropTypes.object,
    birthDate: valueType,
    maritalStatus: valueTypeNumber,
    profileId: PropTypes.number.isRequired,
    statusId: PropTypes.number.isRequired,
    address: PropTypes.object.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    updatedSuccessfully: PropTypes.bool
  }).isRequired,
  expireUpdatedParticipant: PropTypes.func.isRequired,
  updateParticipant: PropTypes.func.isRequired
}

export default Company



// WEBPACK FOOTER //
// ./src/Participant/Profile/Company.js